import moment from "moment";
import React, { useContext, useState } from "react";

// const Assignment = React.createContext();

/* ✅ REAL CONTEXT (exported) */
export const AssignmentContext = React.createContext();

/* ✅ Alias so existing code still works */
const Assignment = AssignmentContext;

export const useAssignment = () => {
  return useContext(Assignment);
};

const newAssignmentInitialValues = {
  id: null,
  assignmentTitle: "",
  instruction: "",
  instructionStyle: {},
  attachments: [
    {
      type: "text",
      info: "",
    },
    {
      type: "voice",
      info: "",
    },
    {
      type: "video",
      info: "",
    },
    {
      type: "avatarVideo",
      info: "",
    },
    {
      type: "link",
      info: [],
    },
    {
      type: "file",
      info: [],
    },
  ],
  assignmentFor: [],
  dueDate: null,
  publishedDate: null,
  scheduledOn: null,
  markingType: "",
  status: "",
  rubric: {},
  aiGrading: false,
};

export const AssignmentProvider = ({ children }) => {
  const [currentAssignmentData, setCurrentAssignmentData] = useState({
    ...newAssignmentInitialValues,
  });
  const [currentAssignmentData_, setCurrentAssignmentData_] = useState(null);

  const [selectedGrades, setSelectedGrades] = useState([]);

  const [currentLessionStudentList, setCurrentLessionStudentList] = useState(
    [],
  );
  const [otherData, setOtherData] = useState({});
  const [isSubmissionsPage, setIsSubmissionsPage] = useState(false);
  const [isSummaryPage, setIsSummaryPage] = useState(false);
  const [isGradingPage, setIsGradingPage] = useState(false);
  const [globalSearchText, setGlobalSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState("");
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [selectedLessonAssignments, setSelectedLessonAssignments] = useState(
    [],
  );
  const [isRubricHasPoints, setIsRubricHasPoints] = useState(false);
  const [isCreatingNew, setIsCreatingNew] = useState(false);

  const toggleClass = (element, classToRemove, classToAdd) => {
    if (element) {
      element.classList.add(classToAdd);
      element.classList.remove(classToRemove);
    }
  };

  const toggleFilter = (action = "open") => {
    const hiddenElement = document.querySelector(".h-ctr");
    const shownElement = document.querySelector(".s-ctr");

    if (action === "open") {
      if (shownElement) {
        toggleClass(shownElement, "s-ctr", "h-ctr");
      }
    } else if (action === "close") {
      if (hiddenElement) {
        toggleClass(hiddenElement, "h-ctr", "s-ctr");
      }
    } else {
      console.warn("toggleFilter: invalid action:", action);
    }
  };

  const stripHtml = (html = "") => html.replace(/<[^>]*>/g, "").trim();

  const isSameDateTime = (a, b) => {
    if (!a && !b) return true;
    if (!a || !b) return false;

    return (
      moment(a).local().format("YYYY-MM-DD") ===
      moment(b).local().format("YYYY-MM-DD")
    );
  };

  const removeIsVisitedDeep = (value) => {
    if (Array.isArray(value)) {
      return value.map(removeIsVisitedDeep);
    }

    if (value && typeof value === "object") {
      const cleaned = {};

      for (const key in value) {
        if (key === "isVisited") continue; // 🔥 IGNORE
        cleaned[key] = removeIsVisitedDeep(value[key]);
      }

      return cleaned;
    }

    return value;
  };

  // const normalizeForCompare = (rubric) => {
  //   if (!rubric) return rubric;

  //   return removeIsVisitedDeep(rubric);
  // };

  const rubricSnapshot = (rubric) =>
    JSON.stringify(rubric, (key, value) => {
      if (key === "isVisited") return undefined;
      if (value === "" || value == null) return undefined;
      return value;
    });

  // const normalizeRubric = (value) => {
  //   if (Array.isArray(value)) {
  //     const cleanedArray = value
  //       .map(normalizeRubric)
  //       .filter(
  //         (v) =>
  //           v !== undefined &&
  //           v !== null &&
  //           (typeof v !== "object" || Object.keys(v).length > 0),
  //       );

  //     return cleanedArray.length > 0 ? cleanedArray : undefined;
  //   }

  //   if (value && typeof value === "object") {
  //     const cleanedObj = {};

  //     for (const key in value) {
  //       if (key === "isVisited") continue; // 🔥 ignore always

  //       const cleanedValue = normalizeRubric(value[key]);

  //       if (
  //         cleanedValue !== undefined &&
  //         cleanedValue !== null &&
  //         cleanedValue !== "" &&
  //         !(
  //           typeof cleanedValue === "object" &&
  //           Object.keys(cleanedValue).length === 0
  //         )
  //       ) {
  //         cleanedObj[key] = cleanedValue;
  //       }
  //     }

  //     return Object.keys(cleanedObj).length > 0 ? cleanedObj : undefined;
  //   }

  //   return value === "" ? undefined : value;
  // };

  const isAssignmentChanged = (defaultData, currentData) => {
    // 1. Simple fields
    if (defaultData.id !== currentData.id) return true;

    if (defaultData.assignmentTitle !== currentData.assignmentTitle)
      return true;
    if (defaultData.instruction !== currentData.instruction) return true;

    const defaultInstructionText = stripHtml(
      defaultData.instructionStyle?.instructionHtmlString || "",
    );

    const currentInstructionText = stripHtml(
      currentData.instructionStyle?.instructionHtmlString || "",
    );

    if (defaultInstructionText !== currentInstructionText) return true;

    // if (defaultData.dueDate !== currentData.dueDate) return true;
    if (!isSameDateTime(defaultData.dueDate, currentData.dueDate)) return true;

    if (!isSameDateTime(defaultData.publishedDate, currentData.publishedDate))
      return true;

    if (!isSameDateTime(defaultData.scheduledOn, currentData.scheduledOn))
      return true;

    if (Number(defaultData.markingType) !== Number(currentData.markingType))
      return true;
    if (defaultData.status !== currentData.status) return true;
    if (defaultData.aiGrading !== currentData.aiGrading) return true;

    // 2. assignmentFor (array)
    if (defaultData.assignmentFor.length !== currentData.assignmentFor.length) {
      return true;
    }

    for (let i = 0; i < defaultData.assignmentFor.length; i++) {
      const user = defaultData.assignmentFor[i];
      if (!currentData.assignmentFor.includes(user)) {
        return true;
      }
    }

    // 3. attachments (manual per type + per index)
    if (defaultData.attachments.length !== currentData.attachments.length)
      return true;

    for (let i = 0; i < defaultData.attachments.length; i++) {
      const d = defaultData.attachments[i];
      const c = currentData.attachments[i];

      if (d.type !== c.type) return true;

      // text / voice / video / avatarVideo
      if (d.type !== "link" && d.type !== "file" && d.info !== c.info) {
        return true;
      }

      // link & file (array)
      if (d.type === "link" || d.type === "file") {
        if (d.info.length !== c.info.length) return true;

        for (let j = 0; j < d.info.length; j++) {
          if (JSON.stringify(d.info[j]) !== JSON.stringify(c.info[j])) {
            return true;
          }
        }
      }
    }

    const isChanged =
      rubricSnapshot(defaultData.rubric) !== rubricSnapshot(currentData.rubric);

    if (isChanged) {
      return true;
    }
    // if (
    //   JSON.stringify(normalizedDefaultRubric) !==
    //   JSON.stringify(normalizedCurrentRubric)
    // ) {
    //   return true;
    // }

    return false; // 🔥 EXACT match
  };

  const hasAnyFormData = (data, isCreatingNew) => {
    if (isCreatingNew) {
      return isAssignmentChanged(newAssignmentInitialValues, data);
    }
    // ✏️ Editing existing assignment → compare with snapshot
    if (!currentAssignmentData_) return false;

    return isAssignmentChanged(currentAssignmentData_, data);
  };

  return (
    <Assignment.Provider
      value={{
        currentAssignmentData,
        setCurrentAssignmentData,
        selectedGrades,
        setSelectedGrades,
        newAssignmentInitialValues,
        currentLessionStudentList,
        setCurrentLessionStudentList,
        setOtherData,
        otherData,
        isSubmissionsPage,
        setIsSubmissionsPage,
        isGradingPage,
        setIsGradingPage,
        globalSearchText,
        setGlobalSearchText,
        currentPage,
        setCurrentPage,
        selectedLesson,
        setSelectedLesson,
        selectedLessonAssignments,
        setSelectedLessonAssignments,
        setIsRubricHasPoints,
        isRubricHasPoints,
        isSummaryPage,
        setIsSummaryPage,
        toggleFilter,
        hasAnyFormData,
        setCurrentAssignmentData_,
        isCreatingNew,
        setIsCreatingNew,
      }}
    >
      {children}
    </Assignment.Provider>
  );
};
